<template>
  <section class="py-20 bg-white">
    <div class="container mx-auto px-4">
      <div class="flex flex-col md:flex-row items-center">
        <div class="md:w-1/2 md:pr-4">
          <div class="relative">
            <img
              src="@/assets/web_pg_2.jpg"
              alt="Magazine Modules"
              class="rounded-lg"
            />
          </div>
        </div>
        <div class="md:w-1/2 mb-10 md:mb-0 md:pl-20">
          <div class="text-title font-bold text-[#333333] leading-tight mb-6">
            VISIT US AT GLOBAL EXHIBITIONS
          </div>
          <div class="text-desc mb-6">
            Each year, we connect with the global market at premier gift fairs
            to stay on the pulse of evolving trends and gain firsthand
            understanding of customer needs for tailored services.
          </div>
          <ul class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 mb-6">
            <li
              class="flex items-start"
              v-for="feature in features"
              :key="feature"
            >
              <i class="fa-regular fa-circle-check text-[#d4335d] mt-1 mr-3"></i>
              <span class="text-[15px] text-[#555555] font-semibold">{{ feature }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Template',
  components: {},
  data () {
    return {
      features: [
        'Hong Kong Gifts & Premium Fair',
        'Bangkok Mega Gifts Show',
        'US ASD Market Week',
        'Tokyo Gift Show',
        'Dubai Gift Show'
      ]
    }
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/page/index/themePreviewSection.vue